import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Plus = ({
  containerClassName,
  className,
  containerHeight = 16,
  width = 3,
  length = 16
}) => {
  const positionCalc = (length - (width / 2)) - (length / 2);
  // horizontal-plus top positioning should be the height of Plus/2 - (horizontal-plus height/2)
  const containerStyleObj = {
    width: `${containerHeight}px`,
    height: `${containerHeight}px`
  };

  const horizontalStyleObj = {
    height: `${width}px`,
    width: `${length}px`,
    top: `${positionCalc}px`,
    left: 0
  };

  const verticalStyleObj = {
    width: `${width}px`,
    height: `${length}px`,
    left: `${positionCalc}px`,
    top: 0
  };

  return (
    <div className={classnames('Plus', containerClassName)} style={containerStyleObj}>
      <div
        className={classnames('bar horizontal-plus bg-gray-600', className)}
        style={horizontalStyleObj}
      />
      <div
        className={classnames('bar vertical-plus bg-gray-600', className)}
        style={verticalStyleObj}
      />
    </div>
  )
}

Plus.propTypes = {
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  containerHeight: PropTypes.number,
  width: PropTypes.number,
  length: PropTypes.number
}

export default Plus;
